"use client";

import dynamic from "next/dynamic";

export const STTAPIWrapper = dynamic(() => import("./STTAPI").then(mod => mod.STTAPI));
